import { call, put, select, takeEvery } from 'redux-saga/effects';
import apiSaga, { apiActionSagaTemplate } from './apiSaga';
import { isEmpty } from 'lodash';

import { parseFilters } from 'services/recommendationParamsService';

import {
  GET_DEFAULT_RECOMMENDATIONS,
  UPDATE_RECOMMENDATION_STATUS,
  GET_MORE_RECOMMENDATIONS,
  GET_FILTERED_RECOMMENDATIONS,
} from 'actionTypes';

import {
  getDefaultRecommendationsSuccess,
  getFilteredRecommendationsSuccess,
  getMoreRecommendationsSuccess,
  updateRecommendationStatusSuccess,
} from 'actions';

import { getPaginationDetails } from 'selectors';

const updateRecommendationStatusSaga = apiActionSagaTemplate(
  updateRecommendationStatusSuccess
);

function* defaultRecommendationsSaga(action) {
  let payload = parseFilters(action.filters);
  yield recommendationsSaga(payload, getDefaultRecommendationsSuccess, action);
}

function* filteredRecommendationSaga(action) {
  let payload = parseFilters(action.filters);
  yield recommendationsSaga(payload, getFilteredRecommendationsSuccess, action);
}

function* getMoreRecommendationsSaga(action) {
  const { next } = yield select(getPaginationDetails, 'recommendations');
  const filters = yield select(state => state.filters);

  if (next === null) {
    return;
  }

  let payload = {
    ...parseFilters(filters),
    page: next,
  };

  yield recommendationsSaga(payload, getMoreRecommendationsSuccess, action);
}

function* recommendationsSaga(payload, successActionCreator, action) {
  const resultUUID = yield select(state => state.currentResult);
  if (!resultUUID) {
    return;
  }

  let response = yield call(
    apiSaga,
    { ...action, endpointArgs: { resultUUID } },
    payload
  );

  if (isEmpty(response.errors)) {
    yield put(successActionCreator(response));
  }
}

export default [
  takeEvery(GET_DEFAULT_RECOMMENDATIONS, defaultRecommendationsSaga),
  takeEvery(GET_FILTERED_RECOMMENDATIONS, filteredRecommendationSaga),
  takeEvery(GET_MORE_RECOMMENDATIONS, getMoreRecommendationsSaga),
  takeEvery(UPDATE_RECOMMENDATION_STATUS, updateRecommendationStatusSaga),
];



// WEBPACK FOOTER //
// ./src/sagas/recommendationsSagas.js